import React from 'react'
import TopBar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import BreadCrumb from '../../Globle/Breadecrumb'
import Career from '../MainCareer/Career'
import Careerabout from '../MainCareer/Careerabout'
import WhoWeAre from '../MainCareer/WhoWeAre'
import Footer1 from '../../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <BreadCrumb title='Career' />
            <Career />
            <Careerabout />
            <WhoWeAre />
            <Footer1 />
        </>
    )
}

export default Main
